export default "dist/images/block-divider-dots.e67cc87.png";